var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isStarted && _vm.dataSource.length
    ? _c(
        "div",
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("history")))]),
          _vm._v(" "),
          _c("HKLTable", {
            attrs: { columns: _vm.columns, dataSource: _vm.dataSource },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }